@if (feasibilityInfo.addressNotFoundError) {
    <app-tooltip
        appCustomPopover
        placement="left"
        popoverType="error"
        popoverText="FEASIBILITY_ADDRESS_NOT_FOUND_ERROR"
        [adaptPlacement]="true"
    >
        <ng-container icon>
            <span class="icon-location-red"></span>
        </ng-container>
    </app-tooltip>
}
@if (feasibilityInfo.generalTaskCapacityError) {
    <app-tooltip
        appCustomPopover
        placement="top"
        popoverType="error"
        popoverText="FEASIBILITY_GENERAL_TASK_CAPACITY_ERROR"
        [adaptPlacement]="true"
    >
        <ng-container icon>
            <span class="icon-absence-red"></span>
        </ng-container>
    </app-tooltip>
}
@if (feasibilityInfo.syncedCapacityError) {
    <app-tooltip
        appCustomPopover
        placement="top"
        popoverType="error"
        popoverText="FEASIBILITY_SYNCED_CAPACITY_ERROR"
        [adaptPlacement]="true"
    >
        <ng-container icon>
            <span class="icon-merge icon-merge-red"></span>
        </ng-container>
    </app-tooltip>
}
@if (feasibilityInfo.workShiftAndSkillLevelError) {
    <app-tooltip
        appCustomPopover
        placement="top"
        popoverType="error"
        popoverText="FEASIBILITY_WORK_SHIFT_AND_SKILL_LEVEL_ERROR"
        [adaptPlacement]="true"
    >
        <ng-container icon>
            <span class="icon-absence-red"></span>
        </ng-container>
    </app-tooltip>
}
@if (feasibilityInfo.visitRestrictionError) {
    <app-tooltip
        appCustomPopover
        placement="top"
        popoverType="error"
        popoverText="FEASIBILITY_VISIT_RESTRICTION_ERROR"
        [adaptPlacement]="true"
    >
        <ng-container icon>
            <span class="icon-visit-restriction"></span>
        </ng-container>
    </app-tooltip>
}
@if (feasibilityInfo.heavyTaskCapacityError) {
    <app-tooltip
        appCustomPopover
        placement="top"
        popoverType="error"
        popoverText="FEASIBILITY_HEAVY_TASK_CAPACITY_ERROR"
        [adaptPlacement]="true"
    >
        <ng-container icon>
            <span class="icon-heavy-weight icon-heavy-weight-red"></span>
        </ng-container>
    </app-tooltip>
}
@if (feasibilityInfo.durationExceedsTimeWindowError) {
    <app-tooltip
        appCustomPopover
        placement="top"
        popoverType="error"
        popoverText="FEASIBILITY_DURATION_EXCEEDS_TIME_WINDOW_ERROR"
        [adaptPlacement]="true"
        position="left"
    >
        <ng-container icon>
            <span class="icon-overtime"></span>
        </ng-container>
    </app-tooltip>
}
@if (feasibilityInfo.skillLevelWarning) {
    <app-tooltip
        appCustomPopover
        placement="top"
        popoverType="error"
        popoverText="FEASIBILITY_SKILL_LEVEL_WARNING"
        [adaptPlacement]="true"
    >
        <ng-container icon>
            <span class="icon-education-orange"></span>
        </ng-container>
    </app-tooltip>
}
@if (feasibilityInfo.tasksOverlappingWarning) {
    <app-tooltip
        appCustomPopover
        placement="top"
        popoverType="error"
        popoverText="FEASIBILITY_TASKS_OVERLAPPING_WARNING"
        [adaptPlacement]="true"
    >
        <ng-container icon>
            <span class="icon-merge icon-merge-orange"></span>
        </ng-container>
    </app-tooltip>
}
@if (feasibilityInfo.noCompatibleEmployeesInTaskToRequiredEmployeeWarning) {
    <app-tooltip
        appCustomPopover
        placement="top"
        popoverType="error"
        popoverText="FEASIBILITY_TASK_TO_REQUIRED_EMPLOYEE_WARNING"
        [adaptPlacement]="true"
    >
        <ng-container icon>
            <span class="icon-merge icon-absence-orange"></span>
        </ng-container>
    </app-tooltip>
}
@if (showOvertime && feasibilityInfo.feasibilityCount === 0) {
    <app-tooltip
        appCustomPopover
        placement="top"
        popoverType="error"
        popoverText="FEASIBILITY_OVERTIME"
        [adaptPlacement]="true"
    >
        <ng-container icon>
            <span class="icon-absence"></span>
        </ng-container>
    </app-tooltip>
}
@if (feasibilityInfo.taskNotActiveError) {
    <app-tooltip
        appCustomPopover
        placement="top"
        popoverType="error"
        popoverText="FEASIBILITY_TASK_NOT_ACTIVE"
        [adaptPlacement]="true"
    >
        <ng-container icon>
            <span class="icon-cross">X</span>
        </ng-container>
    </app-tooltip>
}

